export enum NidessoQueryParams {
  Location = "loc",
  SearchTerm = "q",
  Vacancy = "v",
  OpenVacancies = "ov",
}
